import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from 'react';
import { View } from 'react-native';
import { getDurationPickerWidgetStyles } from './DurationPickerWidgetStyles';
import { Button, getTestId, isValidObject } from '@airtel/air-design-system';
import { Picker } from './components/picker/Picker';
import { getDurationInMS, getEpochTime } from './utils';
export var DurationPickerWidgetComponent = props => {
  var id = props.id,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'DurationPickerWidget' : _props$testID,
    onUserAction = props.onUserAction,
    hourData = props.hourData,
    minData = props.minData,
    buttonWidgetProps = props.buttonWidgetProps,
    onEmptySelectionMetaData = props.onEmptySelectionMetaData,
    onSelectionChangeMetaData = props.onSelectionChangeMetaData,
    style = props.style;
  var durationPickerWidgetStyles = getDurationPickerWidgetStyles();
  var _useState = useState({
      hour: 0,
      min: 0
    }),
    selectedValue = _useState[0],
    setSelectedValue = _useState[1];
  var onItemIndexChange = (value, type) => {
    var updatedState = Object.assign({}, selectedValue);
    if (type === 'hour') {
      updatedState = Object.assign(Object.assign({}, updatedState), {
        hour: value
      });
    } else {
      updatedState = Object.assign(Object.assign({}, updatedState), {
        min: value
      });
    }
    setSelectedValue(updatedState);
    if (!(updatedState === null || updatedState === void 0 ? void 0 : updatedState.hour) && !(updatedState === null || updatedState === void 0 ? void 0 : updatedState.min)) {
      onEmptySelectionMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onEmptySelectionMetaData)));
    }
  };
  var handleButtonPress = () => {
    var duration = getDurationInMS(minData, hourData, selectedValue.min, selectedValue.hour);
    var epoch = getEpochTime(minData, hourData, selectedValue.min, selectedValue.hour);
    onSelectionChangeMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onSelectionChangeMetaData), {
      hour: minData[selectedValue.hour],
      min: minData[selectedValue.min],
      duration: "" + duration,
      epochTime: "" + epoch
    }));
  };
  return _jsxs(Fragment, {
    children: [_jsxs(View, Object.assign({}, getTestId(testID), {
      style: [durationPickerWidgetStyles.carouselView, style]
    }, {
      children: [_jsx(Picker, {
        testID: "picker-component",
        data: hourData,
        getSelectedValue: value => onItemIndexChange(value, 'hour'),
        showText: false,
        selectedIndex: selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.hour,
        isCustomTime: true
      }), _jsx(Picker, {
        data: minData,
        getSelectedValue: value => onItemIndexChange(value, 'min'),
        showText: false,
        selectedIndex: selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.min,
        isCustomTime: true
      })]
    })), isValidObject(buttonWidgetProps) && _jsx(Button, Object.assign({
      disabled: !selectedValue.hour && !selectedValue.min,
      onPress: handleButtonPress
    }, buttonWidgetProps, {
      version: "variable-width"
    }))]
  });
};
DurationPickerWidgetComponent.genericRendererKey = 'AirDurationPickerWidget';